import {useEffect, useState} from 'react';
import {Coordinate} from '../../../types/graphQLTypes';
import fetchElevationLines from './fetchElevationLines';
import {
  SuccessResponse,
} from './simpleCache';

interface Output {
  loading: boolean;
  error: any;
  data: undefined | SuccessResponse;
}

interface Input {
  lineId: string;
  line: null | Coordinate[];
  includeIncline?: boolean;
  includeMinMax?: boolean;
}

const useLineStringElevation = (input: Input): Output => {
  const {line, includeIncline, includeMinMax, lineId} = input;

  const [output, setOutput] = useState<Output>({loading: true, error: undefined, data: undefined});

  useEffect(() => {
    let mounted = true;
    fetchElevationLines({line, includeIncline, includeMinMax, lineId}, out => {
      if (mounted) {
        setOutput(current => ({...current, ...out}));
      }
    });
    return () => {
      mounted = false;
    };
  }, [line, includeIncline, includeMinMax, lineId]);

  return output;
};

export default useLineStringElevation;
